import React, { ChangeEvent, ReactElement } from 'react';

export interface Props {
    claimInfoString: string;
    link: string;
    claimInfoIndex: number;
    selectedClaimInfoIndex: number | null;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
}

const AssetRadioButton = ({
    claimInfoString,
    claimInfoIndex,
    selectedClaimInfoIndex,
    onChange,
}: Props): ReactElement => (
    <label data-testid="asset-radio" className="asset-radio" htmlFor={`${claimInfoIndex}`}>
        <div data-testid="asset-radio__text" className="asset-radio__text">{`${claimInfoString}`}</div>
        <input
            data-testid="asset-input"
            type="checkbox"
            name="vehicle"
            value={claimInfoIndex}
            id={`${claimInfoIndex}`}
            onChange={onChange}
            className="asset-radio__radio"
            checked={selectedClaimInfoIndex !== null && claimInfoIndex === selectedClaimInfoIndex}
        />
        <span data-testid="radio-button" className="asset-radio__radio-button" />
    </label>
);

export default AssetRadioButton;
